
<p-dialog 
  [modal]="true"
  [style]="{width: '100%', maxWidth: '99%'}"
  [maximizable]="true"
  header="CMTA Details"
  styleClass="quick-view-grid-row filterbox " 
  [(visible)]="isVisible" 
  showEffect="fade" 
  (onHide)="closeDialogbox()" 
  appendTo="body">
    <!--Grid Code  -->
    <div class="col-lg-12 nopadding">
        <app-grid 
        [GridColumns]="GridColumns" 
        [Dataset]="dataset"
        PageName="cmtaDetail" 
        [TotalRecords]="totalRecords"
        (RestLimitEvent)="GridChangeLimitEvent($event)"
        (exportData)="exportToCSV($event)"
     >
    </app-grid>
      </div>
</p-dialog>